import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Progress,
  useToast,
} from '@chakra-ui/react';
import { Viewer } from '@react-pdf-viewer/core';
import { SpecialZoomLevel } from '@react-pdf-viewer/core';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import useMobile from 'hooks/useMobile';
import { useRef, useState } from 'react';
import { DocumentService } from 'services/document/document.service';

const TermModal = ({ termUrl, isOpen, onDecline, onAccept, showActions = true }) => {
  const { isMobile } = useMobile();
  const modalDesign = {
    height: isMobile ? '90vh' : '85vh',
    width: isMobile ? '90vw' : '60vw',
    maxWidth: isMobile && '700px',
  };
  const cancelRef = useRef();
  const toast = useToast();

  const [isLoadingAcceptButton, setIsLoadingAcceptButton] = useState(false);
  const [isLoadingDeclineButton, setIsLoadingDeclineButton] = useState(false);
  const [isScrollToBottomTerms, setIsScrollToBottomTerms] = useState(false);

  const handleAccept = () => {
    setIsLoadingAcceptButton(true);
    DocumentService.updateTermsOfServiceStatus()
      .then(() => {
        onAccept();
      })
      .catch(() => {
        toast({
          title: `Accept Terms of Service failed`,
          status: 'error',
          position: 'bottom-right',
          isClosable: true,
        });
        onDecline();
      });
  };

  const zoomPluginInstance = zoomPlugin();

  const handleDecline = () => {
    setIsLoadingDeclineButton(true);
    onDecline();
  };

  const handleLastPageScroll = (e) => {
    if (e.currentPage === e.doc._pdfInfo.numPages - 1) {
      setIsScrollToBottomTerms(true);
    }
  };

  return (
    <>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onDecline}>
        <AlertDialogOverlay>
          <AlertDialogContent {...modalDesign} bg='white'>
            <AlertDialogHeader pt='7' fontSize='3xl' fontWeight='bold'>
              <AlertDialogCloseButton
                zIndex={999}
                m='3'
                color='grey.800'
                fontSize='16'
                _hover={{ bg: 'grey.200' }}
                _focus={{ outline: 'none' }}
              />
            </AlertDialogHeader>

            <AlertDialogBody h='calc(100% - 200px)' p='0'>
              <Box w='100%' h='100%' transform='auto' id='terms_modal_content'>
                {termUrl && termUrl.trim() !== '' ? (
                  <Viewer
                    defaultScale={SpecialZoomLevel.PageWidth}
                    fileUrl={termUrl}
                    plugins={[zoomPluginInstance]}
                    renderLoader={renderLoader}
                    onPageChange={handleLastPageScroll}
                  />
                ) : (
                  <Flex align='center' justify='center' h='100%'>
                    <Box>No terms document available</Box>
                  </Flex>
                )}
              </Box>
            </AlertDialogBody>
            {showActions ? (
              <AlertDialogFooter justifyContent='space-between'>
                <Box maxW='60%' color='gray' fontSize='sm'></Box>
                <Box>
                  <Button
                    ml={3}
                    colorScheme='messenger'
                    isDisabled={isLoadingAcceptButton || !isScrollToBottomTerms}
                    isLoading={isLoadingAcceptButton}
                    onClick={handleAccept}
                    size='sm'
                  >
                    Accept
                  </Button>
                  <Button
                    ref={cancelRef}
                    ml={3}
                    isDisabled={isLoadingDeclineButton}
                    isLoading={isLoadingDeclineButton}
                    onClick={handleDecline}
                    size='sm'
                  >
                    Decline
                  </Button>
                </Box>
              </AlertDialogFooter>
            ) : (
              <Box h='30px'></Box>
            )}
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

const renderLoader = (progress) => {
  return (
    <Flex align='center' justify='center' h='600px'>
      <Box w='240px'>
        <Box textAlign='center'>Loading Terms of Service...</Box>
        <Progress hasStripe value={progress} />
      </Box>
    </Flex>
  );
};

export default TermModal;
